import React from 'react';
import { Flex } from '@mantine/core';
import { t } from 'i18next';
import {
  Colors,
  Text,
  Typography,
  Icon,
  IconName,
} from 'goalsetter-webapp-components';
import {
  Container,
  FirstRowContainer,
  RowsContainer,
  firstRowButtonStyles,
  iconLinkStyle,
  iconStyles,
  linkStyle,
  secondRowStyles,
} from './styles';
import { Link } from 'react-router-dom';
import { useMediaQueryGs } from 'app/hooks/useMediaQuery';
import { TERMS_AND_CONDITIONS_PDF } from 'utils';

export const Footer: React.FC = () => {
  const { isMobile } = useMediaQueryGs();

  return (
    <Container>
      <RowsContainer>
        <FirstRowContainer>
          <Link
            to={String(process.env.REACT_APP_ABOUT)}
            style={linkStyle}
            data-testid="linkAbout"
          >
            <Text
              color={Colors.WHITE}
              type={Typography.GSBUTTON}
              style={firstRowButtonStyles}
            >
              {t('footer.about')}
            </Text>
          </Link>

          <Link
            to={String(process.env.REACT_APP_CONTACT_US)}
            style={linkStyle}
            data-testid="linkContactUs"
          >
            <Text
              color={Colors.WHITE}
              type={Typography.GSBUTTON}
              style={firstRowButtonStyles}
            >
              {t('footer.contactUs')}
            </Text>
          </Link>
          <Link
            to={`${process.env.REACT_APP_API_SITE_URL}${TERMS_AND_CONDITIONS_PDF}`}
            target="_blank"
            style={linkStyle}
            data-testid="linkGoalCardTerms"
          >
            <Text
              color={Colors.WHITE}
              type={Typography.GSBUTTON}
            >
              {t('footer.goalCardTerms')}
            </Text>
          </Link>
        </FirstRowContainer>
        <Flex
          justify="space-between"
          align={isMobile ? 'flex-start' : 'center'}
          style={secondRowStyles}
          direction={isMobile ? 'column' : 'row'}
          gap={'12px'}
        >
          <Text
            color={Colors.WHITE}
            type={Typography.GSCAPTION}
          >
            {t('footer.rights', { year: new Date().getFullYear() })}
          </Text>
          <Flex>
            <Link
              to={String(process.env.REACT_APP_INSTAGRAM)}
              target="_blank"
              style={iconLinkStyle}
              data-testid="linkInstagram"
            >
              <Icon
                icon={IconName.INSTAGRAM}
                size={24}
              />
            </Link>
            <Link
              to={String(process.env.REACT_APP_TWITTER)}
              target="_blank"
              style={iconLinkStyle}
              data-testid="linkTwitter"
            >
              <Icon
                icon={IconName.TWITTER}
                size={24}
                style={iconStyles}
              />
            </Link>
            <Link
              to={String(process.env.REACT_APP_FACEBOOK)}
              target="_blank"
              style={iconLinkStyle}
              data-testid="linkFacebook"
            >
              <Icon
                icon={IconName.FACEBOOK}
                size={24}
                style={iconStyles}
              />
            </Link>
            <Link
              to={String(process.env.REACT_APP_EMAIL)}
              target="_blank"
              style={iconLinkStyle}
              data-testid="linkEmail"
            >
              <Icon
                icon={IconName.EMAIL}
                size={24}
                style={iconStyles}
              />
            </Link>
          </Flex>
        </Flex>
      </RowsContainer>
    </Container>
  );
};
